// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__39x-S","footer":"ModalInfo_footer__261ZR"};